import { Button, Card } from 'antd';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import PageHeaderWrapper from '../../components/PageHeaderWrapper';
import PaginatedDefectsTable from '../../components/PaginatedDefectsTable';
import TFButton from '../../components/TFButton/TFButton';
import { AircraftAuthenticationWrapper } from '../../components/_utils/AuthenticationWrapper';
import { AircraftResource, AircraftPermission } from '../../models/aircraft';
import InnerMenuLayout from '../../layouts/InnerMenuLayout';
import { getSingleAircraft } from '../../models/aircraft/actions';
import ExpandedContent from '../../components/TopNavWrapper/ExpandedContent';
import styles from './DefectsList.module.less';

class AircraftDefectsList extends PureComponent {
  static propTypes = {
    fetchAircraft: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    selectedAircraft: PropTypes.object,
    ttl: PropTypes.number.isRequired,
  };

  static defaultProps = {
    selectedAircraft: undefined,
  };

  state = { loading: true };

  componentDidMount() {
    const { selectedAircraft, ttl, fetchAircraft } = this.props;
    if (!selectedAircraft || Date.now() - selectedAircraft.lastFetched > ttl) {
      fetchAircraft().then(() => {
        this.setState({ loading: false });
      });
    } else if (selectedAircraft.id) {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      history,
      intl: { formatMessage },
      selectedAircraft,
      location: { state: id },
    } = this.props;
    const { loading } = this.state;
    return (
      <InnerMenuLayout loading={loading}>
        <ExpandedContent
          displayTitle={formatMessage({ id: 'title.defects' })}
          action={
            <AircraftAuthenticationWrapper
              aircraftId={selectedAircraft.id}
              requiredResource={AircraftResource.WORKPACK}
              requiredPermissionLevel={AircraftPermission.CREATE}
            >
              <Link to={selectedAircraft ? `/aircraft/${selectedAircraft.id}/defects/add` : ''}>
                <TFButton skinny padding="0 15px" handleClick={() => null}>
                  {formatMessage({ id: 'form.button.addWorkpack' })}
                </TFButton>
              </Link>
            </AircraftAuthenticationWrapper>
          }
        />
        <div className={styles.card}>
          <div className={styles.tableList}>
            {selectedAircraft?.id ? (
              <PaginatedDefectsTable history={history} aircraft={selectedAircraft} defectId={id} />
            ) : null}
          </div>
        </div>
      </InnerMenuLayout>
    );
  }
}

export default compose(
  injectIntl,
  withRouter,
  connect(
    (
      { aircraft },
      {
        match: {
          params: { id },
        },
      },
    ) => ({
      selectedAircraft: aircraft.aircraftMap.get(id),
      ttl: aircraft.ttl,
    }),
    (
      dispatch,
      {
        match: {
          params: { id },
        },
      },
    ) => ({
      fetchAircraft: () => {
        return dispatch(
          getSingleAircraft({
            payload: id,
          }),
        );
      },
    }),
  ),
)(AircraftDefectsList);
